export default function displaySuccess() {
  const sucessIcon = document.querySelector('.success-check');
  sucessIcon.classList.add('zoom');

  setTimeout(function() {
    sucessIcon.classList.remove('zoom');
  }, 1000);
}
